import { useExplore } from '@/stores/explore';
import { cn } from '@skand/ui';
import { lengthToString } from '@skand/viewer-component-v2';
import { Vector3 } from 'three';
import { Item } from './Item';

interface SegmentLength {
  label: string;
  value: string;
}

interface SegmentsProps {
  points: Vector3[];
}

export const Segments = ({ points }: SegmentsProps) => {
  const measurementUnit = useExplore(state => state.measurementUnit);

  const calculateSegmentLengths = (points: Vector3[]): SegmentLength[] => {
    const result: SegmentLength[] = [];

    if (points.length < 2) return result;

    for (let i = 0; i < points.length - 1; i++) {
      const a = new Vector3(points[i].x, points[i].y, points[i].z);
      const b = new Vector3(points[i + 1].x, points[i + 1].y, points[i + 1].z);
      const length = a.distanceTo(b);

      result.push({
        label: `Segment (P${i + 1} - P${i + 2})`,
        value: lengthToString(parseFloat(length.toFixed(3)), measurementUnit, 4),
      });
    }

    return result;
  };

  const segments = calculateSegmentLengths(points);

  return (
    <div className={cn('flex flex-col justify-between')}>
      {segments.map((segment, index) => (
        <Item key={index} label={segment.label} value={segment.value} />
      ))}
    </div>
  );
};
